import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import {observer} from "mobx-react"
import { HashRouter as Router, Route, Link } from "react-router-dom"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AnimatedSwitch } from 'react-router-transition';


@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){

  }
  componentWillUnmount(){
  }

  render () {
    return (
      <React.Fragment>
      <Router>

      {/*<Route path="/" exact component={Explications}/>*/}

      <ToastContainer
        position="top-right"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange={false}
        draggable={false}
        />

      </Router>
      </React.Fragment>
    );
  }
}

export default Routeur
